import script from "./TradesTotals.vue?vue&type=script&setup=true&lang=js"
export * from "./TradesTotals.vue?vue&type=script&setup=true&lang=js"

import "./TradesTotals.vue?vue&type=style&index=0&id=45927b28&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-45927b28"]])

export default __exports__